(function() {
	'use strict';

	// Polyfill for the closest function
	if (!Element.prototype.closest) {
		Element.prototype.closest = function(s) {
			var el = this;
			if (!document.documentElement.contains(el)) return null;
			do {
					if (el.matches(s)) return el;
					el = el.parentElement || el.parentNode;
			} while (el !== null && el.nodeType === 1);
			return null;
		};
	}

	// Send info to Google Analytics
	function analytics(action, label) {
		window.dataLayer.push({
			'event': 'Interactive',
			'category': 'Interactive',
			'action': action,
			'label': label
		});
	}

	// Return the right label for analytics tracking, else return an empty string
	function getLabel(element) {
		if (element.closest("[href='#dar__category-1']")) return 'historys_revenge';
		if (element.closest("[href='#dar__category-2']")) return 'europes_debate';
		if (element.closest("[href='#dar__category-3']")) return 'democracy_in_asia';
		if (element.closest("[href='#dar__category-4']")) return 'middle_east_west_asia';
		if (element.closest("[href='#dar__category-5']")) return 'emerging_players';
		if (element.closest("[href='#dar__dashboard']")) return 'democracy_disorder_project';
		if (element.closest("[href*='/democracy-disorder-the-struggle-for-influence-in-the-new-geopolitics/")) return 'main_report';
		return '';
	}

	function app() {

		// Get the current nav and make a copy of it
		const nav = document.querySelector('.dar__nav');
		const navCopy = nav.cloneNode(true);

		// Remove the current one
		nav.parentNode.removeChild(nav);

		// Add the copy to the header
		const mainNav = document.querySelector('.site-header');
		if (mainNav) mainNav.appendChild(navCopy);

		// Add events for analytics
		const dashboard = document.querySelector('.dar__dashboard');
		dashboard.addEventListener('click', function(event) {
			const label = getLabel(event.target);
			if (label != '') analytics('button_click', label);
		}, true);

		const navNew = document.querySelector('.dar__nav');
		navNew.addEventListener('click', function(event) {
			const label = getLabel(event.target);
			if (label != '') analytics('nav_click', label);
		}, true);
	}

	// Start the whole thing when the DOM is complete
	document.addEventListener('readystatechange', function() {
		document.readyState === 'interactive' && app();
	}, false);

})();
